import EventEmitter from "events"
import {IPFS} from "ipfs-core"
import OrbitDB from "orbit-db"
import KeyValueStore from "orbit-db-kvstore"
import {useCallback, useContext, useEffect, useRef, useState} from "react"
import {BackendContext} from "../context/BackendContext"
import {getOrbitAddress, notifyUpdate} from "../functions/ipfs-orbit"
import {IssueDB} from "../models/IssueDB.model"

export const useFetchIssueDB = (repoId?: string) => {
  const {orbit, ipfs} = useContext(BackendContext)
  const [db, setDB] = useState<IssueDB>()
  const [replCnt, setReplCnt] = useState(0)
  const replEvent = useRef<EventEmitter>()

  const fetchIssueDB = useCallback(async (
    ipfs: IPFS,
    orbit: OrbitDB,
    dbName: string
  ) => {
    const address = await getOrbitAddress(
      orbit,
      `${dbName}-issue`,
      "keyvalue",
      {
        accessController: {
          write: ["*"]
        }
      }
    )
    await notifyUpdate(ipfs, address)
    const db = await orbit.keyvalue(address) as IssueDB
    await db.load()
    replEvent.current = db.events.on("replicated", () => {
      setReplCnt(prevState => prevState + 1)
    })
    setDB(db)
  }, [])

  useEffect(() => {
    if (!orbit || !ipfs || !repoId) {
      return
    }
    fetchIssueDB(ipfs, orbit, repoId).then()
  }, [orbit, ipfs, repoId])

  useEffect(() => {
    return () => {
      replEvent.current?.removeAllListeners()
    }
  }, [])

  useEffect(() => {
    if (!db) {
      return
    }

    return () => {
      console.log(`closing ${db.address.toString()}`)
      db?.close().then(_ => {
        console.log(`closed ${db.address.toString()}`)
      })
    }
  }, [db])

  return {
    issueDB: db,
    issueReplCnt: replCnt,
    setIssueReplCnt: setReplCnt
  }
}
